import { Routes } from '@angular/router';

import { AdminLayoutComponent, AuthLayoutComponent } from './core';
import { AuthGuard } from './auth/auth.guard';
import { SiteResolver } from './main/common/site/site.resolver';
import {
  SchedulerMonitorReportComponent
} from './main/scheduler/component/schedule-manager/component/scheduler-monitor-report/scheduler-monitor-report.component';
import { BiggerPictureMessagesGuard } from './shared/guards/bigger-picture-messages.guard';
import { MOI } from './shared/enums/moi.enum';
import { RouteGuard } from './auth/route.guard';

export const AppRoutes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [{
      path: '',
      loadChildren: () => import('./main/main.module').then(m => m.MainModule)
    }],
    canActivate: [AuthGuard, BiggerPictureMessagesGuard],
    data: {moi: MOI.SYSTEM},
    canActivateChild: [RouteGuard, AuthGuard],
    resolve: {
      // menuItems: SidebarResolver,
      allowedSites: SiteResolver
    }
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [{
      path: 'session',
      loadChildren: () => import('./session/session.module').then(m => m.SessionModule)
    }],
    canActivate: [AuthGuard]
  },
  {
    path: 'schedule-monitor',
    component: SchedulerMonitorReportComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard, BiggerPictureMessagesGuard],
    data: {moi: MOI.SCHEDULE_MANAGER},
  },
  {
    path: '**',
    redirectTo: 'session/404'
  }
];
